import { IFormParsed } from '@infotech-soe/metaschema';

import { FormSource } from '../view-model/FormSource';

import FormSchemaFactory from './FormSchemaFactory';

class ConditionFormSchemaFactory extends FormSchemaFactory {
  public async get(source: FormSource): Promise<IFormParsed> {
    const formSchema = await this.schemaRepository.getForm(
      source.category,
      source.form
    );

    if (formSchema) {
      return formSchema;
    }

    throw new Error(
      `Can't get form schema for form: ${source.form} in category: ${source.category}`
    );
  }
}

export default ConditionFormSchemaFactory;
